<template>
    <div class="instructor-chat">
        <div class="select-chat-users">
            <v-select class="v-select-item" :no-data-text="$t('no_data')" outlined dense item-text="title"
                      item-value="role" :items="roles" v-model="selectedTab"
                      @change="showUsers"/>
            <v-select class="v-select-item" :no-data-text="$t('no_data')" outlined dense item-text="classTitle"
                      item-value="classId" :items="classes" v-model="selectedClassId" @change="showUsersByClass"
                      v-if="selectedTab === 'student'"/>
        </div>
        <Chat ref="chat"/>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
import Chat from '@/components/chat/Chat'
export default {
  name: 'StudentChat',
  components: {
    Chat
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  data () {
    return {
      roles: [
        { role: 'teacher', title: this.$t('teachers') },
        { role: 'student', title: this.$t('students') },
          { role: 'admin', title: 'Оператор школы' },
          { role: 'group', title: 'Группы' }
        // { role: 'parent', title: this.$t('parents') }
      ],
      classes: [],
      selectedTab: '',
      selectedClassId: ''
    }
  },
  mounted () {
    this.getInstrClasses()
    this.showUsers('teacher')
  },
  methods: {
    showUsers (role) {
      this.selectedTab = role
      this.selectedClassId = ''
      this.$refs.chat.selectedRole = role
      this.$refs.chat.recipientUserId = ''
      this.$refs.chat.users = []
      this.$refs.chat.messages = []
      this.$refs.chat.allReserveUsers = []
      if (role === 'teacher' || role === 'group' || role === 'admin') {
        this.$refs.chat.fetchUsers(this.selectedTab)
      }
    },

    showUsersByClass (classId) {
      this.$refs.chat.fetchUsers(this.selectedTab, classId)
    },

    getInstrClasses () {
      // instructorClassService.getByInstructorId(this.userProfile.personId).then((res) => {
      //   if (res._embedded) {
      //     this.classes = res._embedded.instructorClassResourceList.map((klass) => {
      //       klass.classTitle = klass.classLevel + klass.classLabel
      //       return klass
      //     })
      //   }
      // })
    }
  }
}
</script>

<style scoped>

</style>
